// extracted by mini-css-extract-plugin
module.exports = {"reject-button":"styles_reject-button__3WK2y"};